/* unplugin-vue-components disabled */import { render } from "./qrCode3.vue?vue&type=template&id=1df3c246&scoped=true"
import script from "./qrCode3.vue?vue&type=script&lang=js"
export * from "./qrCode3.vue?vue&type=script&lang=js"

import "./qrCode3.vue?vue&type=style&index=0&id=1df3c246&scoped=true&lang=css"
import "./qrCode3.vue?vue&type=style&index=1&id=1df3c246&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df3c246"]])

export default __exports__